module.exports = __webpack_public_path__ + "img/software_test.97644c6d.jpg";